import {
    MapOptions
} from "@esdm/map/dist";
import { PortsmouthBaseLayerTypes } from "./PortsmouthBaseMapping_3857";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {

        let opt = new MapOptions();
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [
            PortsmouthBaseLayerTypes.PortsmouthOS,
            //PortsmouthBaseLayerTypes.PortsmouthAerial,
            PortsmouthBaseLayerTypes.PortsmouthOSSixInch,
            PortsmouthBaseLayerTypes.PortsmouthOS25inch,
            PortsmouthBaseLayerTypes.PortsmouthOS1250
        ];
        opt.defaultBaseMap = PortsmouthBaseLayerTypes.PortsmouthOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 18;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 12;
        opt.minZoom = 10;
        opt.maxZoom = 20;

        opt.extent = [-130919, 6580494, -113029, 6596277];
        opt.mapCentre = [
                -120051, 6589592
        ];

        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;
        return opt;
    }

}
